















































































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import cloneDeep from 'lodash/cloneDeep'
import listMixin from '@/mixins/list'
import configurationApi from '@/api/configuration'
import visitorApi from '@/api/visitor'
import { passwordReg } from '@/utils/regExp'
import { formatDate } from '@/web-task/filter'
import Upload from '@/components/Upload/index.vue'
import { uuid } from '@/utils/util'

@Component({
	name: 'Holiday',
	components: {
		PageLayout,
		Upload,
	},
})
export default class Configuration extends Mixins(listMixin) {
	private columns: any = [
		{
			title: '序号',
			align: 'center',
			dataIndex: 'key',
			scopedSlots: { customRender: 'key' },
			width: 100,
		},
		{
			title: '日期',
			align: 'center',
			dataIndex: 'holidayDate',
			scopedSlots: { customRender: 'holidayDate' },
			width: 200,
		},
		{
			title: '节假日名称',
			align: 'center',
			dataIndex: 'holidayName',
			width: 200,
		},
		{
			title: '节假日类型',
			align: 'center',
			dataIndex: 'holidayType',
			width: 160,
		},
	]
	private tableData: any = []
	private yearList: any = []
	private currentYear: any = ''
	public created() {
		const year = new Date().getFullYear()
		this.currentYear = year
		for (let i = 2018; i <= year; i++) {
			this.yearList.push(i)
		}
		this.getList()
	}

	private downloadTemplate() {
		const a = document.createElement('a')
		a.href = '/节假日维护模板.xlsx'
		a.download = '节假日维护模板.xlsx'
		a.click()
		a.remove()
	}

	private async importTemplate() {
		const res = await (this.$refs.upload as any).getSingle()
		const formData = new FormData()
		formData.append('file', res)
		formData.append('year', this.searchForm.getFieldValue('year'))
		await configurationApi.holidayImport(formData)
		this.$message.success('导入成功')
		this.getList()
	}

	public async getList() {
		this.$nextTick(async () => {
			const res = await configurationApi.getHolidayList({
				year: this.searchForm.getFieldValue('year'),
				pageSize: 8888,
				pageNum: 1,
			})
			this.tableData = res.data.retList.map((item: any) => {
				return {
					...item,
					key: uuid(),
				}
			})
		})
	}
}
